export const M3_NAV = [
  { id: "about", label: "About", icon: "person" },
  { id: "experience", label: "Experience", icon: "work_history" },
  { id: "projects", label: "Projects", icon: "deployed_code" },
  { id: "engineering", label: "Engineering", icon: "memory" },
  { id: "resume", label: "Résumé", icon: "description" },
  { id: "publications", label: "Publications", icon: "menu_book" },
  { id: "talks", label: "Talks", icon: "mic" },
  { id: "awards", label: "Awards", icon: "trophy" },
  { id: "writing", label: "Writing", icon: "edit_note" },
  { id: "reading", label: "Reading", icon: "auto_stories" },
  { id: "contact", label: "Contact", icon: "mail" },
] as const;

export type NavId = (typeof M3_NAV)[number]["id"];
